<template>
    <div>
		<form-sidebar>
			<v-layout wrap>
				<v-subheader>Recurso: {{ resourceName }}</v-subheader>
			</v-layout>
			<v-layout wrap>
				<v-flex xs12 pb-3>
					<app-table
						class="mt-3 table-rows no-main-list"
						name="roles-access-resources"
						:columns="columns"
						:check-all="checkAll"
						:rows="services"
						:main-list="false"
						selectable
						@row-is-selected="rowIsSelected"
						@on-selected-all="allIsSelected"
					>
						<template slot="rows" slot-scope="props">
							<td v-show="showRow(columns, 1)">
								{{ props.row.domain }}
							</td>
							<td v-show="showRow(columns, 2)">
								{{ props.row.method }}
							</td>
							<td v-show="showRow(columns, 3)">
								{{ props.row.path }}
							</td>
							<td v-show="showRow(columns, 4)">
								{{ props.row.name }}
							</td>
							<td v-show="showRow(columns, 5)">
								<v-checkbox
									color="success"
									class="pl-2"
									v-model="props.row.authorize"
									hide-details>
								</v-checkbox>
							</td>
						</template>
					</app-table>
				</v-flex>
			</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button
					:is-loading="loading"
					:on-run-service="loading"
					@accept-button-clicked="saveServices"
					@cancel-button-clicked="closeModal"
				/>
			</section>
		</form-sidebar>
    </div>
</template>

<script>
	function closeModal() {
		this.$emit('close-modal');
	}

	async function loadData() {
		try {
			const { data: response } = await this.$http.get('web-services', { params: this.params });
			const arrayPermission = Object.keys(this.resourcePermission);
			if (arrayPermission.length) {
				this.services = response.data.map((r) => {
					const newService = { ...r };
					const index = arrayPermission.findIndex(a => Number(a) === r.id);
					newService.isSelected = index > -1 ? true : newService.isSelected;
					newService.authorize = index > -1 ? this.resourcePermission[r.id] : newService.authorize;
					return newService;
				});
			} else {
				this.services = response.data;
			}
			this.dataSelected = this.services.filter(s => s.isSelected);
		} catch (error) {
			this.showError();
		}
	}

	function rowIsSelected(row) {
		this.services = this.selectIsRow(this.services, 'isSelected', row);
		if (row.isSelected) {
			this.dataSelected.push(row);
		} else {
			const index = this.dataSelected.findIndex(d => d.id === row.id);
			this.dataSelected.splice(index, 1);
		}
		this.checkAll = this.services.every(s => s.isSelected);
	}

	function allIsSelected(value) {
		this.checkAll = value;
		this.services = this.services.map((s) => {
			const newService = { ...s };
			newService.isSelected = value;
			return newService;
		});
	}

	function saveServices() {
		this.$emit('save-services', this.services, this.resourceId);
	}

	function created() {
		this.params = {
			resourceId: this.resourceId,
			roleId: this.roleId,
		};
		this.loadData();
	}

	function data() {
		return {
			actionParams: {
				codeProject: '',
				resourceId: 0,
			},
			services: [],
			checkAll: false,
			columns: [
				{ id: 1, name: 'Dominio', checked: true, visible: true },
				{ id: 2, name: 'Método', checked: true, visible: true },
				{ id: 3, name: 'URI', checked: true, visible: true },
				{ id: 4, name: 'Nombre', checked: true, visible: true },
				{ id: 5, name: 'Auth', checked: true, visible: true },
			],
			loading: false,
			selectedValue: 'flagSelected',
			version: {
				Accept: `${process.env.ACCEPT_SERVICE_V2}`,
			},
			params: {},
			dataSelected: [],
		};
	}

	export default {
		name: 'role-access-services',
		data,
		created,
		methods: {
			allIsSelected,
			closeModal,
			loadData,
			rowIsSelected,
			saveServices,
		},
		props: {
			resourceId: {
				type: [Number, String],
				required: true,
			},
			resourceName: {
				type: String,
				required: true,
			},
			roleId: {
				type: [Number, String],
				required: true,
			},
			resourcePermission: {
				type: Object,
				default: () => {},
			},
		},
	};
</script>




// WEBPACK FOOTER //
// src/components/roles/role-access-services.vue